'use es6';

export const POPUP_TOP = 'POPUP_TOP';
export const POPUP_LEFT = 'POPUP_LEFT';
export const POPUP_RIGHT = 'POPUP_RIGHT';
export const CALLOUT_LEFT = 'CALLOUT_LEFT';
export const CALLOUT_RIGHT = 'CALLOUT_RIGHT';
export const POP_UP = 'POP_UP';
export const SLIDE_IN_BOTTOM_LEFT = 'SLIDE_IN_BOTTOM_LEFT';
export const SLIDE_IN_TOP_LEFT = 'SLIDE_IN_TOP_LEFT';
export const SLIDE_IN_BOTTOM_RIGHT = 'SLIDE_IN_BOTTOM_RIGHT';
export const SLIDE_IN_TOP_RIGHT = 'SLIDE_IN_TOP_RIGHT';

// for web surveys using the web interactive config
export const STICKY_BANNER_TOP = 'STICKY_BANNER_TOP';
export const STICKY_BANNER_BOTTOM = 'STICKY_BANNER_BOTTOM';